import { defineStore } from "pinia";
import { ref } from "vue";
import { escalationsService } from "@/services/escalationsService";
/** The sidebar badge: how many escalations need a person in the acting company. */
export const useEscalationsStore = defineStore("escalations-store", () => {
    const openCount = ref(0);
    async function fetchOpenCount() {
        try {
            const { open } = await escalationsService.count();
            openCount.value = open;
        }
        catch {
            /* the badge is a convenience; a failed poll keeps the last value */
        }
        return openCount.value;
    }
    function setOpenCount(count) {
        openCount.value = count;
    }
    return { openCount, fetchOpenCount, setOpenCount };
});
